var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "search-table" },
        [
          _c("el-date-picker", {
            staticClass: "custom-date-picker",
            staticStyle: { width: "115px" },
            attrs: {
              clearable: false,
              type: "month",
              placeholder: "Chọn tháng",
              "value-format": "M-yyyy",
              format: "MM-yyyy",
              "time-arrow-control": false,
            },
            on: { change: _vm.handelUpdateDate },
            model: {
              value: _vm.monthAndYear,
              callback: function ($$v) {
                _vm.monthAndYear = $$v
              },
              expression: "monthAndYear",
            },
          }),
          _c(
            "el-select",
            {
              staticClass: "input-common",
              staticStyle: { width: "120px" },
              attrs: { placeholder: "Trạng thái" },
              on: { change: _vm.handleChangeKidStatus },
              model: {
                value: _vm.dataSearch.kidStatus,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "kidStatus", $$v)
                },
                expression: "dataSearch.kidStatus",
              },
            },
            _vm._l(_vm.kidStatusListExcel, function (item) {
              return _c("el-option", {
                key: item.key,
                attrs: { value: item.key, label: item.value },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "input-common input-grade",
              staticStyle: { width: "203px" },
              attrs: { placeholder: "Chọn nhóm" },
              on: { change: _vm.handleChangeKidGroup },
              model: {
                value: _vm.dataSearch.idGroup,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "idGroup", $$v)
                },
                expression: "dataSearch.idGroup",
              },
            },
            _vm._l(_vm.kidGroupList, function (item, index) {
              return _c("el-option", {
                key: index,
                attrs: { value: item.id, label: item.nameGroup },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "203px" },
              attrs: {
                placeholder: "Chọn trạng thái",
                multiple: "",
                "collapse-tags": "",
                clearable: "",
              },
              on: {
                change: _vm.handleChangeMoneyStatus,
                "remove-tag": _vm.handleChangeMoneyStatus,
                clear: _vm.handleChangeMoneyStatus,
              },
              model: {
                value: _vm.statusList,
                callback: function ($$v) {
                  _vm.statusList = $$v
                },
                expression: "statusList",
              },
            },
            _vm._l(_vm.statusOrderList, function (item, index) {
              return _c("el-option", {
                key: index,
                attrs: { value: item, label: item },
              })
            }),
            1
          ),
          _c(
            "el-input",
            {
              staticClass: "input-common input-class",
              staticStyle: { width: "240px" },
              attrs: { clearable: "", placeholder: "Nhập tên, biệt danh" },
              on: { clear: _vm.handleClearKidName },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.handleChangeKidName.apply(null, arguments)
                },
              },
              model: {
                value: _vm.kidName,
                callback: function ($$v) {
                  _vm.kidName = $$v
                },
                expression: "kidName",
              },
            },
            [
              _c("el-button", {
                attrs: { slot: "append", icon: "el-icon-search" },
                on: { click: _vm.handleSearchResultByName },
                slot: "append",
              }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "input-common",
              staticStyle: { width: "100px" },
              attrs: { placeholder: "Đợt thu" },
              on: { change: _vm.handleChangeCollectionTurn },
              model: {
                value: _vm.dataSearch.collectionTurn,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "collectionTurn", $$v)
                },
                expression: "dataSearch.collectionTurn",
              },
            },
            _vm._l(_vm.collectionTurn, function (item) {
              return _c("el-option", {
                key: item,
                attrs: { value: item, label: `Đợt ${item}` },
              })
            }),
            1
          ),
          _c("el-button", { on: { click: _vm.additionFilter } }, [
            _c("i", {
              staticClass: "el-icon-circle-plus",
              style: { color: _vm.showAddFilterColor() },
            }),
          ]),
          _vm.checkFilter()
            ? _c(
                "el-button",
                {
                  style: { color: _vm.showResetFilerColor() },
                  on: {
                    click: function ($event) {
                      return _vm.resetFilterDefault()
                    },
                  },
                },
                [_c("i", { staticClass: "el-icon-refresh" })]
              )
            : _vm._e(),
          _vm.loadingBill === true
            ? _c(
                "span",
                {
                  staticClass: "loading_title",
                  staticStyle: { color: "red", "text-align": "right" },
                },
                [
                  _vm._v("Dữ liệu đang được xử lý... "),
                  _c("span", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingBill,
                        expression: "loadingBill",
                      },
                    ],
                  }),
                ]
              )
            : _vm._e(),
          _vm.loadingUpdate === true
            ? _c("span", { staticClass: "loading_title" }, [
                _vm._v("Đang cập nhật điểm danh... "),
                _c("span", {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingUpdate,
                      expression: "loadingUpdate",
                    },
                  ],
                }),
              ])
            : _vm._e(),
          _vm.bulkPayments === true
            ? _c("span", { staticClass: "loading_title" }, [
                _vm._v("Đang cập nhật thanh toán toàn bộ... "),
                _c("span", {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.bulkPayments,
                      expression: "bulkPayments",
                    },
                  ],
                }),
              ])
            : _vm._e(),
          _vm.checkRevenue
            ? _c(
                "el-button",
                {
                  staticClass: "custom_button",
                  staticStyle: { float: "right" },
                  attrs: {
                    type: "success",
                    icon: "el-icon-plus",
                    size: "medium",
                  },
                  on: { click: _vm.handleOpenAddNameExpensesDialog },
                },
                [_vm._v("\n      Thêm khoản\n    ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._t("default"),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "15px" } },
        [
          _c(
            "el-col",
            {
              staticStyle: {
                display: "inline-flex",
                "justify-content": "right",
              },
              attrs: { span: 20, offset: 4 },
            },
            [
              _c("el-pagination", {
                staticStyle: {
                  "margin-right": "5.2rem",
                  "margin-left": "auto",
                },
                attrs: {
                  "current-page": _vm.currentPagePagination,
                  "page-sizes": _vm.listSizeLimit,
                  "page-size": _vm.sizeLimit,
                  layout: " prev, pager,sizes, next",
                  total: _vm.sizeLimit * _vm.totalPages,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    _vm.currentPagePagination = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.currentPagePagination = $event
                  },
                },
              }),
              _c(
                "el-menu",
                {
                  staticStyle: { "margin-right": "1.2rem" },
                  attrs: {
                    "background-color": "#67C23A",
                    "text-color": "#FFFFFF",
                    "active-text-color": "#FFFFFF",
                    "unique-opened": true,
                    "menu-trigger": "hover",
                    mode: "horizontal",
                  },
                  on: { select: _vm.handleCommand },
                },
                [
                  _c(
                    "el-submenu",
                    { attrs: { index: "1" } },
                    [
                      _c("template", { slot: "title" }, [_vm._v("Tác vụ")]),
                      _vm.updateAttendanceForGroup === true
                        ? _c(
                            "el-menu-item",
                            { attrs: { index: "updateAttendanceData" } },
                            [_vm._v("Cập nhật điểm danh\n          ")]
                          )
                        : _vm._e(),
                      _c(
                        "el-submenu",
                        { attrs: { index: "2" } },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v("Phiếu thu"),
                          ]),
                          _c(
                            "el-menu-item",
                            { attrs: { index: "2-createInvoice" } },
                            [_vm._v("Khởi tạo khoản thu")]
                          ),
                          _c(
                            "el-menu-item",
                            { attrs: { index: "2-pdfPreview" } },
                            [_vm._v("In phiếu thu 1 liên")]
                          ),
                          _c(
                            "el-menu-item",
                            { attrs: { index: "2-pdfSplit" } },
                            [_vm._v("In phiếu thu 2 liên")]
                          ),
                          _c(
                            "el-menu-item",
                            { attrs: { index: "2-exportAllBill" } },
                            [_vm._v("Xuất phiếu thu theo tháng\n            ")]
                          ),
                          _c(
                            "el-menu-item",
                            { attrs: { index: "2-deleteOrder" } },
                            [_vm._v("Hủy phiếu thu")]
                          ),
                          _vm.listHiddenOrderKids
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "2-openOrder" } },
                                [_vm._v("Khôi phục phiếu thu")]
                              )
                            : _vm._e(),
                          _vm.listHiddenOrderKids
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "2-destroyOrder" } },
                                [_vm._v("Xóa phiếu thu")]
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                      _c(
                        "el-submenu",
                        { attrs: { index: "3" } },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v("Xuất Excel tổng hợp"),
                          ]),
                          _c(
                            "el-menu-item",
                            { attrs: { index: "3-exportExcel" } },
                            [_vm._v("Theo đợt đã chọn")]
                          ),
                          _c(
                            "el-menu-item",
                            { attrs: { index: "3-exportAllExcel" } },
                            [_vm._v("Theo tất cả các đợt")]
                          ),
                        ],
                        2
                      ),
                      _c(
                        "el-submenu",
                        { attrs: { index: "4" } },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v("Gửi học phí"),
                          ]),
                          _c(
                            "el-menu-item",
                            { attrs: { index: "4-sendApp" } },
                            [_vm._v("Gửi qua Onekids")]
                          ),
                          _c(
                            "el-menu-item",
                            { attrs: { index: "4-sendSMS" } },
                            [_vm._v("Gửi SMS")]
                          ),
                        ],
                        2
                      ),
                      _c(
                        "el-submenu",
                        { attrs: { index: "5" } },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v("Mẫu học phí"),
                          ]),
                          _c(
                            "el-menu-item",
                            { attrs: { index: "5-uploadTemplateSchool" } },
                            [_vm._v("Upload File mẫu")]
                          ),
                          _c(
                            "el-menu-item",
                            { attrs: { index: "5-deleteTemplateSchool" } },
                            [_vm._v("Xóa File mẫu")]
                          ),
                          _c(
                            "el-menu-item",
                            { attrs: { index: "5-instructUploadFileSample" } },
                            [_vm._v("Hướng dẫn sử dụng")]
                          ),
                        ],
                        2
                      ),
                      _c(
                        "el-menu-item",
                        { attrs: { index: "showListForApp" } },
                        [_vm._v("Hiển thị")]
                      ),
                      _c(
                        "el-menu-item",
                        { attrs: { index: "hiddenListForApp" } },
                        [_vm._v("Bỏ hiển thị")]
                      ),
                      _c(
                        "el-menu-item",
                        { attrs: { index: "createNoteExcel" } },
                        [_vm._v("Tạo ghi chú")]
                      ),
                      _vm.checkPermission(["fees_2_excel_cash_payment"])
                        ? _c(
                            "el-menu-item",
                            { attrs: { index: "allCashier" } },
                            [_vm._v("Thanh toán hàng loạt")]
                          )
                        : _vm._e(),
                      _c(
                        "el-menu-item",
                        { attrs: { index: "registerBankForOrder" } },
                        [_vm._v("Chọn TK thanh toán trực tuyến")]
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "font-family": "Roboto,serif" },
                  attrs: {
                    type: "success",
                    icon: "el-icon-link",
                    size: "medium",
                  },
                  on: { click: _vm.handleOpenExportTempDialog },
                },
                [_vm._v("\n        Xuất mẫu học phí\n      ")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "font-family": "Roboto,serif" },
                  attrs: {
                    type: "success",
                    icon: "el-icon-link",
                    size: "medium",
                  },
                  on: { click: _vm.handleImportCheckerForGroup },
                },
                [_vm._v("\n        Nhập từ Excel\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("addition-filter", {
        ref: "AdditionFilter",
        attrs: { "dialog-visible": _vm.showAdditionFilter },
        on: { "dialog-close": _vm.handleCloseAddition },
      }),
      _c("UploadTemplateSchoolForGroup", {
        attrs: {
          kidGroupList: _vm.kidGroupList,
          idGroup: _vm.dataSearch.idGroup.toString(),
          isOpenUploadTemplateSchool: _vm.openUploadTemplateSchool,
        },
        on: { close: _vm.handleCloseUploadTemplateSchool },
      }),
      _c("DeleteTemplateSchoolForGroupDialog", {
        attrs: { "is-dialog-template-visible": _vm.isOpenDeleteTemplate },
        on: { closeTemplateDeleteDialog: _vm.handleCloseTemplateDeleteDialog },
      }),
      _c("ExportTemplateForGroupDialog", {
        attrs: { isOpenExportTemplateDialog: _vm.isOpenExportTemplateDialog },
        on: { closeExportTemplateDialog: _vm.handleCloseExportTemplateDialog },
      }),
      _c("CreateNoteForGroupDialog", {
        attrs: { isOpenCreateNote: _vm.createNote },
        on: { closeNoteDialog: _vm.handleCloseNoteDialog },
      }),
      _c("SendAppForGroupDialog", {
        ref: "SendAppDialog",
        attrs: { "dialog-visible-ex": _vm.dialogVisibleEx },
        on: { close: _vm.handleCloseSendApp },
      }),
      _c("KidExcelImportCheckerForGroup", {
        ref: "checkDataBeforeUploadDialog",
        attrs: { isOpenImportChecker: _vm.isOpenExcelChecker },
        on: {
          closeCheckerDialog: _vm.handleCloseImportChecker,
          refreshCollectionTurn: _vm.handleRefreshCollectionTurn,
        },
      }),
      _c("AllCashierForGroup", {
        ref: "AllCashierForGroup",
        attrs: {
          isOpenAllCashierDialog: _vm.showAllCashierDialog,
          bulkPayments: _vm.bulkPayments,
        },
        on: {
          "update:bulkPayments": function ($event) {
            _vm.bulkPayments = $event
          },
          "update:bulk-payments": function ($event) {
            _vm.bulkPayments = $event
          },
          "dialog-close": _vm.closeAllCashierDialog,
        },
      }),
      _c("AddNameExpensesGroup", {
        attrs: { isOpenAddNameExpensesDialog: _vm.showAddNameExpensesDialog },
        on: { close: _vm.closeAddNameExpensesDialog },
      }),
      _c("ExportTuitionFormDialog", {
        attrs: {
          isOpenExportTuitionFormDialog: _vm.isOpenExportTuitionFormDialog,
          "is-export-all-excel": _vm.isExportAllExcel,
        },
        on: {
          closeExportTuitionFormDialog: _vm.handleCloseExportTuitionFormDialog,
          "update:monthAndYear": _vm.updateMonthAndYear,
        },
      }),
      _c("RegisterBankForOrderDialog", {
        attrs: {
          isOpenRegisterBankForOrderDialog:
            _vm.isOpenRegisterBankForOrderDialog,
          month: _vm.registerBankForOrder.month,
          year: _vm.registerBankForOrder.year,
          turn: _vm.registerBankForOrder.turn,
          idKids: _vm.registerBankForOrder.idKids,
          idGroup: _vm.registerBankForOrder.idGroup,
        },
        on: { close: _vm.closeRegisterBankForOrderDialog },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }